module.exports = __webpack_public_path__ + "media/images/emblems/Riviera-coat_of_arms-a474ccceb4167abd0adac6b6579cb07c.svg";